import { atom } from 'recoil';
import { IFaixaSalarial } from '../../commons/types/programa';


export const faixasSalariaisAtom = atom<IFaixaSalarial[]>({
  key: 'faixaSalarials', 
  default: [] as IFaixaSalarial[],
}); 
